import React, { FunctionComponent } from "react";
import { SearchBar } from "../searchBar/SearchBar";
import { FilterDropDown, FilterDropDownItem } from "./FilterDropDown";
import { formatMessage, formatMessageWithParams } from "../../../utils/helpers/LanguageHelper";

export type FilterItem = Omit<FilterDropDownItem, "active">;

interface FilterBarProps {
  onFilter: (query: string, activeFilters: any[]) => void;
  searchTrigger?: "change" | "enter";
  currentQuery: string;
  currentFilters: string[];
  filters?: FilterItem[];
  itemsFound?: number;
  searchTransform?: (query: string) => string;
  styles?: {
    root?: React.CSSProperties;
    info?: React.CSSProperties;
  };
}

export const FilterBar: FunctionComponent<FilterBarProps> = ({
  onFilter,
  searchTrigger = "change",
  currentQuery = "",
  currentFilters = [],
  filters = [],
  itemsFound = undefined,
  searchTransform = (query: string) => query.trim().toLowerCase(),
  styles = {},
}) => {
  return (
    <div>
      <div
        style={
          styles?.root ?? {
            display: "flex",
            alignItems: "center",
            width: "100%",
            padding: "12px 0px 0px 0px",
          }
        }
      >
        <SearchBar
          onSearch={(query) => {
            onFilter(query, currentFilters);
          }}
          currentQuery={currentQuery}
          searchTrigger={searchTrigger}
          transform={searchTransform}
          variant="compact"
        />
        {filters?.length > 0 && (
          <FilterDropDown
            filters={filters.map((f) => ({
              ...f,
              active: currentFilters.includes(f.value),
            }))}
            setActiveFilters={(f) => {
              onFilter(currentQuery, f);
            }}
          />
        )}
      </div>
      {((currentQuery && currentQuery !== "") || currentFilters?.length > 0) && (
        <div
          style={
            styles?.info ?? {
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: "12px",
              marginRight: "8px",
            }
          }
        >
          {itemsFound !== undefined ? (
            <div style={{ fontSize: "12px", color: "#787878" }}>
              {formatMessageWithParams("cof.base.itemsfound", { count: itemsFound })}
            </div>
          ) : (
            <div></div>
          )}
          <button
            style={{
              fontSize: "12px",
              fontWeight: "bold",
              border: "none",
              background: "none",
              color: "var(--color-blue)",
              cursor: "pointer",
            }}
            onClick={(e) => {
              e.preventDefault();
              onFilter("", []);
            }}
          >
            {formatMessage("cof.objectlist.filterbar.clearfilter")}
          </button>
        </div>
      )}
    </div>
  );
};
